import type { CurrentUser } from "@nabble/sdk";
import { OrganizationSwitcher, useToast } from "@nabble/ui";
import { useLocation } from "react-router-dom";
import { selectOrganization, setOrganizationView } from "../api/me";
import { errorMessage } from "../errors";
import { roleNames } from "../model/organizationRoles";
import { reloadInModule } from "../model/reloadInModule";
import { seesCombinedView } from "./userRoleLabel";

/** The sidebar's organization picker: one organization, or all of the user's together. */
export function ShellOrganizationSwitcher({ user }: { user: CurrentUser }): React.JSX.Element {
  const location = useLocation();
  const { show } = useToast();
  const combined = user.organizationView === "COMBINED";

  async function switchTo(change: () => Promise<void>): Promise<void> {
    try {
      await change();
      reloadInModule(location.pathname);
    } catch (err) {
      show({ title: "We couldn't switch organization", text: errorMessage(err, "Please try again."), tone: "danger" });
    }
  }

  return (
    <OrganizationSwitcher
      organizations={user.organizations.map((o) => ({ id: o.id, name: o.name, hint: roleNames(o.roles) }))}
      selectedId={user.organization?.id ?? null}
      combined={seesCombinedView(user)}
      onSelect={(id) =>
        void switchTo(async () => {
          await selectOrganization(id);
          if (combined) await setOrganizationView("SINGLE");
        })
      }
      onCombine={() => void switchTo(() => setOrganizationView("COMBINED"))}
    />
  );
}
